<div class="pdf-list-calc-cell"
     [style.font-size.px]="fontSize"
     [style.font-weight]="fontWeight">
  <ng-container *ngIf="!hasOverride">
    <span class="calc-label" *ngIf="showLabel && label">{{ label }}</span>
    <span class="calc-value">
      {{ calculatedValue !== null ? formattedValue : '--' }}
    </span>
  </ng-container>
  <span *ngIf="hasOverride" class="calc-value">{{ formattedValue }}</span>
</div>
